const CONTROL_HANDLERS = [];
export function doFormControlHandler(element, controller) {
    const { type } = element;
    for (const handler of CONTROL_HANDLERS) {
        if (handler.supportsControlType(type)) {
            return handler.doControlRender(element, controller);
        }
    }
    return element;
}
export function registerFormControlHandler(handler) {
    CONTROL_HANDLERS.push(handler);
}
